<template lang="pug">
	svg.polysvg(viewBox="0 0 1264 710" style="position: absolute; top: 0; right: 0; bottom: 0; left: 0;")
		g(:transform="svgtransform" @click="click" v-html="svgcontent")
</template>

<script>
// fall back for mousevent path for non-chrome browsers
const getPath = mouseevent => {
	const path = [];
	let currentElem = mouseevent.target;
	while (currentElem) {
		path.push(currentElem);
		currentElem = currentElem.parentElement;
	}
	if (!path.includes(window) && !path.includes(document)) path.push(document);
	if (!path.includes(window)) path.push(window);
	return path;
};

module.exports = {
	data() {
		return {
			svg: null
		};
	},
	mounted() {
		this.svg = this.loadSvg(this.svgpath);
	},
	props: {
		region: {
			type: String,
			default: 'alps'
		},
		urlquery: {
			type: String,
			default: ''
		},
		svgtransform: {
			type: String,
			required: true
		},
		area: {
			type: String,
			required: true
		}
	},
	computed: {
		svgpath() {
			const region = this.region === 'alps' ? 'alps' : 'europe';

			return `/static_content/polygons_${region}.svg`;
		},
		svgcontent() {
			if (this.svg) {
				if (this.svg.getElementById(this.area + '-group')) {
					this.svg
						.getElementById(this.area + '-group')
						.setAttribute('class', 'active');
				}
				return new XMLSerializer().serializeToString(
					this.svg.getElementById('destinations')
				);
			}
			return '';
		}
	},
	methods: {
		loadSvg: url => {
			const xhr = new XMLHttpRequest();
			xhr.open('GET', url, false);
			xhr.send('');
			return xhr.responseXML.documentElement;
		},
		click(e) {
			const path = e.path || getPath(e);

			for (const el of path) {
				if (el.id) {
					const slug = el.getAttribute('slug');
					this.$router.push(
						this.localePath({
							name: 'areas-area-forecast',
							params: { area: slug },
							hash: this.urlquery
						})
					);
					break;
				}
			}
		}
	}
};
</script>

<style lang="sass">
.polysvg
	g
		cursor: pointer
	polygon
		fill: #fff
		fill-opacity: 0.1
	.active
		polygon
			stroke: #fff
			stroke-width: 2
			fill-opacity: 0.3

		.label
			rect
				fill-opacity: 1

	.label:hover
		rect
			fill-opacity: 1
</style>
